import Header from '../components/general/Header';
import Footer from '../components/general/Footer';
import site from '../data/master.json';
import Origin from '../components/story/Origin';
import Gallery from '../components/story/Gallery';
import Culture from '../components/story/Culture';
import Team from '../components/story/Team';
import s from '../styles/pages/ViewStory.module.css';
import RewardsToast from '../components/rewards/RewardsToast';


export default function ViewStory() {
  return (
    <div>
      <main className={s.container}>
        <Header />
          <Origin data={site.origin} />
          <Gallery data={site.gallery} />
          <Culture data={site.culture} />
          <Team data={site.team} />
        <Footer data={site.footer} />
        <RewardsToast />
      </main>
    </div>
  );
}